// extracted by mini-css-extract-plugin
export default {"root":"ViewLectureModal_root__CNnUT","listSection":"ViewLectureModal_listSection__m7reH","lectureList":"ViewLectureModal_lectureList__gjtYI"};